import type { SiteConfig } from "../api/types";
import { CHARITY_PLACEHOLDER, PLEDGE_FALLBACK } from "./facts";

/**
 * The charity sentence, derived once and rendered everywhere. The name is
 * withheld until the charity has agreed in writing, so the null case is the
 * normal case, not an error state.
 */
export function charitySentence(config: SiteConfig | null): string {
  const name = config?.charity.name ?? null;
  if (!name) {
    return "The charity will be named here once it has agreed in writing. It has not endorsed $TISM.";
  }
  if (config?.charity.consent) {
    return `${name} has agreed in writing to be named as the recipient. It has not endorsed $TISM and is not involved in running it.`;
  }
  return `${name} has not endorsed $TISM and is not involved in running it.`;
}

/** A noun phrase for mid-sentence use, which never invents a name. */
export function charityLabel(config: SiteConfig | null): string {
  return config?.charity.name ?? CHARITY_PLACEHOLDER;
}

/** The pledge wording the server publishes. */
export function pledgeText(config: SiteConfig | null): string {
  return config?.charity.pledge ?? PLEDGE_FALLBACK;
}
